/**
 * Best-effort Slidecon funnel beacon. Posts {event} to
 * /api/slidecon/funnel/event. Never throws, never blocks UI.
 *
 * Stages:
 *   v70_toast_seen      → user saw the "Slidecon is now included" toast
 *   info_hint_seen      → user saw the "?" auto-tooltip
 *   explainer_opened    → MySlideconWidget rendered on /profile
 *   slideshow_clicked   → user pressed the Slideshow button
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const recordSlideconFunnelEvent = (event) => {
  try {
    // fetch with credentials: 'include' + keepalive so we send the session
    // cookie and the request survives navigation. Fire-and-forget.
    fetch(`${BACKEND_URL}/api/slidecon/funnel/event`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event }),
      keepalive: true,
    }).catch(() => { /* silent */ });
  } catch {
    /* silent — funnel tracking must never block UX */
  }
};
